import { Dropdown } from "primereact/dropdown";

interface REIDropDownProps {
  id?: string;
  testId?: string;
  value: any;
  onSelectionChange: (e: any) => void;
  data: any[];
  label: string;
  placeholder?: string;
  className?: string;
  optionValue?: string;
  isDisabled?: boolean;
}

const REIDropDown: React.FC<REIDropDownProps> = ({
  id,
  testId,
  value,
  onSelectionChange,
  data,
  label,
  placeholder,
  className = "w-full md:w-14rem",
  optionValue = "value",
  isDisabled,
}) => {
  return (
    <Dropdown
      inputId={id}
      data-testid={testId ?? id}
      value={value}
      onChange={onSelectionChange}
      options={data}
      optionLabel={label}
      placeholder={placeholder}
      style={{ fontSize: "10px" }}
      optionValue={optionValue}
      className={className}
      disabled={isDisabled}
    />
  );
};

export default REIDropDown;
